export const toCurrency = (value, decimal = 2) => {
  if (typeof parseFloat(value) !== "number") {
    return value;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  });

  return formatter.format(value);
}

export const toSmartCurrency = (value) => {
  if (typeof parseFloat(value) !== "number") {
    return value;
  }
  let decimal = 0;
  if ((value % 1) !== 0) {
    decimal = 2;
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  });

  return formatter.format(value);
}

export const dollars = (value, wholeDollars = false) => {
  if (typeof parseFloat(value) !== "number") {
    return value;
  } else if (typeof value === 'string') {
    return (Math.round(value) / 100).toFixed(2);
  }

  if (wholeDollars) {
    return Math.round(value / 100);
  } else {
    return Math.round(value) / 100;
  }
}

export const toDate = (value) => {
  return new Date(value).toLocaleDateString();
}

export const numberWithCommas = (value) => {
  if (typeof value === 'number') {
    return Number(value).toLocaleString();
  }
  return value;
}

export const convertToCents = (value) => {
  if (typeof value === 'string') {
    try {
      return parseInt(value) * 100;
    } catch (error) {
      return null;
    }
  }
  return value * 100;
}
